import React from 'react';
import PropTypes from 'prop-types';
import sortBy from 'lodash/sortBy';
import { FormattedMessage } from 'react-intl';

import FiveCardRow from 'Features/Bundle/components/Templates/GridTemplates/FiveCardRow';
import FourCardRow from 'Features/Bundle/components/Templates/GridTemplates/FourCardRow';
import Price from 'Components/Utility/Price/Price';
import SixCardRow from 'Features/Bundle/components/Templates/GridTemplates/SixCardRow';
import ThreeCardRow from 'Features/Bundle/components/Templates/GridTemplates/ThreeCardRow';

const templateSelector = (tier, tierIndex, switchCarouselGame, bundleSlug) => {
  const filteredBundleTier = sortBy(tier.games, ['sort_order']).filter(game => game.display);

  if (filteredBundleTier.length === 6) {
    return (
      <div className="fan-grid-container">
        <SixCardRow
          filteredBundleTier={filteredBundleTier}
          switchCarouselGame={switchCarouselGame}
          bundleSlug={bundleSlug}
        />
      </div>
    );
  }

  if (
    filteredBundleTier.length === 4 ||
    filteredBundleTier.length === 7 ||
    filteredBundleTier.length === 8 ||
    filteredBundleTier.length === 11 ||
    filteredBundleTier.length === 12
  ) {
    return (
      <div className="fan-grid-container">
        <FourCardRow
          filteredBundleTier={filteredBundleTier}
          switchCarouselGame={switchCarouselGame}
          bundleSlug={bundleSlug}
        />
      </div>
    );
  }

  if (
    filteredBundleTier.length === 2 ||
    filteredBundleTier.length === 3
  ) {
    return (
      <div className="fan-grid-container">
        <ThreeCardRow
          filteredBundleTier={filteredBundleTier}
          switchCarouselGame={switchCarouselGame}
          bundleSlug={bundleSlug}
        />
      </div>
    );
  }

  return (
    <div className="fan-grid-container">
      <FiveCardRow
        filteredBundleTier={filteredBundleTier}
        switchCarouselGame={switchCarouselGame}
        bundleSlug={bundleSlug}
      />
    </div>
  );
};

const tierTitle = (tier, tierIndex, product, payWhatYouWant, giveaway) => {
  if (product.bundles.length === 1) {
    return false;
  }
  return (
    <React.Fragment>
      <FormattedMessage
        id="comictieredbundle.tier"
        defaultMessage="Tier {tierNumber} - {pay} {price}"
        values={{
          tierNumber: tierIndex + 1,
          pay: giveaway && tierIndex === 0 ? '' : <FormattedMessage id="comictieredbundle.tier.pay" defaultMessage="Pay" />,
          price: <Price price={tier.price} />,
        }}
      />
      {payWhatYouWant &&
        <FormattedMessage
          id="comictieredbundle.ormoretounlock"
          defaultMessage=" or more to unlock"
          values={{
            tierNumber: tierIndex + 1,
            price: <Price price={tier.price} />,
          }}
        />
      }
    </React.Fragment>
  );
};

export default function ComicTieredBundle({
  bundleTiers,
  product,
  switchCarouselGame,
  payWhatYouWant,
}) {
  const { giveaway } = product;
  return (
    <div className="bundle-games-container">
      {bundleTiers.map((tier, tierIndex) =>
        <section key={tier._id} className="tier">
          <h2 className="h4 tier-title">
            {tierTitle(tier, tierIndex, product, payWhatYouWant, giveaway)}
            {tierIndex > 0 && <span> - <FormattedMessage id="comictieredbundle.including" defaultMessage="Including products above" /></span>}
          </h2>

          {tier.games.length >= 1 &&
            <div>
              {templateSelector(tier, tierIndex, switchCarouselGame, product.slug)}
            </div>
          }
        </section>,
      )}
    </div>
  );
}

ComicTieredBundle.propTypes = {
  bundleTiers: PropTypes.arrayOf(PropTypes.shape({})),
  product: PropTypes.shape({}),
  switchCarouselGame: PropTypes.func,
  payWhatYouWant: PropTypes.bool,
};

ComicTieredBundle.defaultProps = {
  bundleTiers: [],
  product: {},
  switchCarouselGame: () => { },
  payWhatYouWant: false,
};
